import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';
import Contact from './components/contact';
import Home from './pages/Home';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import About from './pages/About';
import Map from './pages/Map';
import Gallery from './pages/Gallery';
import GlobePage from './pages/3DGlobe';
const Portfolio = React.lazy(() => import('./pages/Portfolio'));

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<React.Suspense fallback={<div>Loading...</div>}><Portfolio /></React.Suspense>} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/map" element={<Map />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/globe" element={<GlobePage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
